import { EllipsisVertical, Pencil, Pin, Trash2 } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

interface ConversationItemMenuProps {
  onRename: () => void;
  onDelete: () => void;
  isPinned?: boolean;
  onTogglePin?: () => void;
  className?: string;
}

export function ConversationItemMenu({
  isPinned,
  onRename,
  onTogglePin,
  onDelete,
  className,
}: ConversationItemMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={`focus-ring rounded-md p-1 text-muted-foreground hover:bg-muted hover:text-foreground ${className ?? ''}`}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <EllipsisVertical className="h-3.5 w-3.5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" side="right" sideOffset={4} onCloseAutoFocus={(e) => e.preventDefault()}>
        <DropdownMenuItem
          onClick={(e) => {
            e.stopPropagation();
            onRename();
          }}
        >
          <Pencil className="mr-2 h-3.5 w-3.5" />
          Rename
        </DropdownMenuItem>
        {onTogglePin && (
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              onTogglePin();
            }}
          >
            <Pin
              className={`mr-2 h-3.5 w-3.5 ${isPinned ? 'fill-current text-primary' : ''}`}
            />
            {isPinned ? 'Unpin' : 'Pin'}
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          className="text-destructive focus:text-destructive"
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        >
          <Trash2 className="mr-2 h-3.5 w-3.5" />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
